<template>
  <div>
    <ConclusionStep
      status="information"
      title="Atualização do cadastro em análise"
      description="Recebemos suas informações e estamos revisando os dados que você enviou. Avisaremos assim que a análise for concluída."
      @close="goToNextRoute"
    >
      <template #button-primary>
        <ButtonPrimary
          label="Voltar para a Home"
          data-testid="continue-button"
          size="large"
          @click="goToNextRoute"
        />
      </template>
    </ConclusionStep>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { ConclusionStep, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { goToNextRoute } from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { trackContinue, trackView } from './track-events';

@Component({
  components: { ButtonPrimary, ConclusionStep }
})
export default class RegulatoryUpdateSuccess extends Vue {
  public goToNextRoute() {
    trackContinue();
    goToNextRoute();
  }

  mounted() {
    trackView();
  }
}
</script>
